import { useAuthState } from '../../services/auth';
import { useEffect, useState } from 'react'
import axios from 'axios';

//import useBreadcrumbs from "use-react-router-breadcrumbs";
import { useNavigate } from 'react-router-dom';
import { Table, Pagination, Collapse } from 'react-bootstrap';


export const Dnsresponse = () => {
  //const user: User = useUserState();
  const {token} = useAuthState();
  const [currentPage, setCurrentPage] = useState(1);
  const [dnsResponses, setDnsResponses] = useState<any[]>([])
  const [totalCount, setTotalCount] = useState<any>(1)
  const [pageSize, setPageSize] = useState<any>(1)
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    if (token) {
      fetchDnsResponses();    }
  }, [token, currentPage]);


  async function fetchDnsResponses() {
    const data = await axios.get('/op/dns/get_all_results?page='+currentPage+'&pageSize=10');
    setTotalCount(data.data.totalCount);
    setPageSize(data.data.pageSize);
    setDnsResponses(data.data.items);
    console.log('aqui', data.data.items)
  }

  const totalPages = Math.ceil(totalCount / pageSize);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };
  const handleItemClick = (item: any) => {
    setActiveItem(activeItem === item ? null : item);
  };

  function formatDateTime(dateString: any) {
    const date = new Date(dateString);

    const formattedDate = date.toLocaleDateString('en-US', {
        year: 'numeric',
        day: '2-digit',
        month: '2-digit',
      });
    const formattedTime = date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
    const formattedDateTime = `${formattedDate} ${formattedTime}`;

    return formattedDateTime;
  }

  const getPageItems = () => {
    const pageItems = [];
    const maxPageItems = 5;
    const maxPageItemsDelta = Math.floor(maxPageItems / 2);
    const startPage = Math.max(currentPage - maxPageItemsDelta, 1);
    const endPage = Math.min(currentPage + maxPageItemsDelta, totalPages);

    if (startPage > 1) {
      pageItems.push(
        <Pagination.Ellipsis key="start-ellipsis" disabled />
      );
    }

    for (let pageNumber = startPage; pageNumber <= endPage; pageNumber++) {
      const isCurrentPage = pageNumber === currentPage;
      pageItems.push(
        <Pagination.Item
          key={pageNumber}
          active={isCurrentPage}
          onClick={() => handlePageChange(pageNumber)}
        >
          {pageNumber}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      pageItems.push(
        <Pagination.Ellipsis key="end-ellipsis" disabled />
      );
    }

    return pageItems;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      fetchDnsResponses();
    }, 1000 * 60 * 1);

    return () => clearInterval(interval);
  }, []);


  return (
    <>
        <Table striped bordered hover>
            <thead>
            <tr>
                <th>Date</th>
                <th>Result</th>
            </tr>
            </thead>
            <tbody>
            {dnsResponses.map((item: any) => (

                <>
                <tr style={item.result ? {}: {backgroundColor:'#f8d7da'}} key={item.uuid} onClick={() => handleItemClick(item)}>
                <td>{formatDateTime(item.responses[0].createdAt)}</td>
                <td>{item.result ? 'Success': 'Fail'}</td>
                </tr>
                <tr>
                <td colSpan={2}>
                <Collapse in={activeItem === item}>
                        <Table bordered>
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>Fqdn</th>
                                <th>Should be</th>
                                <th>Result</th>
                            </tr>
                        </thead>
                        <tbody>

                        {item.responses.map((response: any) => (
                            <tr style={response.result ? {}: {backgroundColor:'#f8d7da'}}  key={response.dnsQueryId}>
                            <td>{response.description} </td>
                            <td> {response.fqdn} </td>
                            <td> {response.shouldBe ? 'Allowed': 'Blocked'} </td>
                            <td> {response.result ? 'Success': 'Fail'}</td>
                            </tr>
                        ))}
                        </tbody>
                        </Table>
                    </Collapse>
                </td>
                </tr>
                </>
            ))}
            </tbody>
        </Table>
        <Pagination>
            <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
            />
            <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
            />
            {getPageItems()}
            <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            />
            <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
            />
        </Pagination>
    </>
  )
}
